<script setup lang="ts">
/** Barre d'accès rapide (mobile). */
const view = useCurrentView()
const isEntity = (k: string): boolean => (view.value.type === 'entity' || view.value.type === 'detail') && view.value.key === k

const items = computed(() => [
  { label: 'Accueil', ico: 'layout-dashboard', act: () => goTo('dashboard'), on: view.value.type === 'dashboard' },
  { label: 'Étudiants', ico: 'backpack', act: () => goTo('entity', 'etudiants'), on: isEntity('etudiants') },
  { label: 'Inscriptions', ico: 'clipboard-list', act: () => goTo('entity', 'inscriptions'), on: isEntity('inscriptions') },
  { label: 'Versements', ico: 'credit-card', act: () => goTo('entity', 'versements'), on: isEntity('versements') },
  { label: 'Menu', ico: 'menu', act: () => toggleSidebar(), on: false },
])
</script>

<template>
  <nav
    id="tabbar"
    class="tabbar"
    aria-label="Accès rapide"
  >
    <button
      v-for="item in items"
      :key="item.label"
      type="button"
      :class="{ active: item.on }"
      :aria-current="item.on ? 'page' : undefined"
      @click="item.act()"
    >
      <AppIcon :name="item.ico" /><span>{{ item.label }}</span>
    </button>
  </nav>
</template>
